import browserHistory from '../utils/browserHistory';
import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';

const { dispatch } = store;
let isUpdatePage = false;
let delayInAddRequest = 10;
let idAddRequest = null;
let requests = [];
let curPathname = window.location.pathname;

const PaceProgressActions = {
    init() {
        browserHistory.listen(location => {
            if (curPathname !== location.pathname) {
                PaceProgressActions.startUpdatePage();
                curPathname = location.pathname;
            }
        });
    },

    startUpdatePage() {
        isUpdatePage = true;

        PaceProgressActions.active();
    },

    endUpdatePage() {
        isUpdatePage = false;

        Promise.all(requests).then(() => {
            requests = [];
            PaceProgressActions.clear();
        });
    },

    addRequest(promise) {
        if (!isUpdatePage) {
            return;
        }

        requests.push(promise);
        PaceProgressActions.totalIncrement();

        clearTimeout(idAddRequest);
        idAddRequest = setTimeout(PaceProgressActions.endUpdatePage, delayInAddRequest);

        promise.then(() => {
            PaceProgressActions.uploadedIncrement();
        }).catch(err => {
            PaceProgressActions.uploadedIncrement();
        });
    },

    active() {
        dispatch({
            type: AppConstants.PACE_PROGRESS_ACTIVE,
        });
    },

    totalIncrement() {
        dispatch({
            type: AppConstants.PACE_PROGRESS_TOTAL_INCREMENT,
        });
    },

    uploadedIncrement() {
        dispatch({
            type: AppConstants.PACE_PROGRESS_UPLOADED_INCREMENT,
        });
    },

    clear() {
        dispatch({
            type: AppConstants.PACE_PROGRESS_CLEAR,
        });
    }
};

export default PaceProgressActions;
